import type { ParamDef, ParamValue } from './types'

/**
 * Mirrors echo-quant's real `build_cli_flags` (spec 036 OQ-1): a true bool is
 * `--name`, a declared bool that is false is `--no-name` (never `--name
 * false`), everything else `--name value`.
 *
 * With `defs`, every declared param is emitted in declaration order. Without
 * `defs` (legacy mode) values are emitted in object order and a false bool is
 * omitted, since nothing says it was declared.
 */
export function buildCliFlags(values: Record<string, ParamValue>, defs?: ParamDef[]): string[] {
  const flags: string[] = []
  const push = (name: string, value: ParamValue, declaredBool: boolean): void => {
    if (typeof value === 'boolean') {
      if (value) flags.push(`--${name}`)
      else if (declaredBool) flags.push(`--no-${name}`)
      return
    }
    flags.push(`--${name}`, String(value))
  }
  if (defs) {
    for (const def of defs) {
      const value = values[def.name] ?? def.default
      if (value === null || value === undefined) continue
      push(def.name, value, def.kind === 'bool')
    }
  } else {
    for (const [name, value] of Object.entries(values)) push(name, value, false)
  }
  return flags
}

function quoteToken(token: string): string {
  if (token === '' || /\s/.test(token)) return `'${token.replace(/'/g, `'\\''`)}'`
  return token
}

/** Joins tokens into one printable line, single-quoting any token with whitespace. */
export function formatCliLine(flags: string[]): string {
  return flags.map(quoteToken).join(' ')
}
